const Backbone = require('backbone');

const FacetGroupModel = Backbone.Model.extend({
	productUrl: '/search?',
	contentUrl: '/search?',
	destroy: function() {
		// prevents delete xhr call when calling model.destroy();
		delete this.attributes.id;
		Backbone.Model.prototype.destroy.apply(this, arguments);
	},
	defaults() {
		return {
			dictionaryTerm: null,
			groupName: '',
			groupDisplayName: '',
			id: '',
			isCollapsed: true,
			resultValues: [],
			selected: false,
			selectedFacetQueries: [],
			selectedValues: '',
			isRanged: false,
			min: 0,
			max: 0,
			mean: 0,
			stddev: 0,
			sum: 0
		};
	},
	encodeQueryParams: function(queryParams) {
		return queryParams.map((queryParam) => {
			let splitParam = queryParam.split('=');
			return `${encodeURIComponent(splitParam[0])}=${encodeURIComponent(splitParam[1])}`;
		});
	},
	parse(response = {}, options = {}) {
		let currentModel;
		if (options.isCollectionFetch) {
			currentModel = response;
		} else {
			currentModel = this.toJSON();
			if (response.length) {
				let queryParams = this.getQueryParams(this.attributes.selectedFacetQueries);
				let encodedQueryParams = this.encodeQueryParams(queryParams);
				response.forEach((result) => {
					result.selected = queryParams.includes(result.facetQuery) || encodedQueryParams.includes(result.facetQuery);
					result.url = this.url(queryParams);
					result.groupName = this.attributes.groupName;
					result.isCollapsed = this.attributes.isCollapsed;
				});
				currentModel.resultValues = response;
				currentModel.moreRefinements = false;
			}
		}
		const newModel = this.collection.parse({ facets: [currentModel], info: this.collection.info });
		if (newModel.length) {
			// parse returns array with a single model object
			return newModel[0];
		}
		return currentModel;
	},
	getQueryParams(selectedFacetQueries, noSelectedFacets) {
		const dl = window.dataLayer,
			queryParams = Object.assign([], selectedFacetQueries),
			source = this._getSourceParamValue(window.location.search),
			sortBy = dl.sortBy.selectedValue;
		let pageSize = 0,
			page = 0;
		if (dl.pagination) {
			pageSize = dl.pagination.pageSize;
			page = dl.pagination.activePage;
		}
		if (source) {
			queryParams.push(source);
		}
		if (dl.search) {
			queryParams.push(`term=${dl.search.name}`);
		}
		if (noSelectedFacets) {
			return queryParams;
		}

		queryParams.push(`r=${pageSize}`);

		if (sortBy) {
			queryParams.push(`s=${sortBy}`);
		}

		if (page) {
			queryParams.push(`p=${page}`);
		}

		if (dl.categoryId) {
			queryParams.push(`categoryId=${dl.categoryId}`);
		} else if (dl.isPla) {
			queryParams.push(`term=application_string:"${dl.product.application}" type_string:"${dl.product.type}"`);
		}
		return queryParams;
	},

	url(queryParams) {
		const dl = window.dataLayer,
			isProductUrl = Boolean(dl.categoryId || dl.search || dl.isPla),
			url = isProductUrl ? this.productUrl : this.contentUrl;
		return url + queryParams.map((param) => param).join('&');
	},

	_getSourceParamValue: function(query) {
		let sourceParamValue = window.BCOM.util.getQueryStringParameter('source', query);
		if (!sourceParamValue) {
			return '';
		}
		return this._returnPlaSourceQuery(sourceParamValue);
	},
	_returnPlaSourceQuery: function(source) {
		const plaMatchers = ['fb-allprod-ret_', 'gba', 'msn-pa_'];
		for (let matcher of plaMatchers) {
			if (source.indexOf(matcher) > -1) {
				return `source=${source}`;
			}
		}
		return '';
	}
});
module.exports = FacetGroupModel;
